import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { Fragment } from 'react';
import { useRecoilState } from 'recoil';

import PerformancesIcon from '@/assets/vectors/menu/finance.svg';
import { menuSelector } from '@/components/state/MenuState';
import { useCurrentAgent } from '@/hooks/agents/useCurrentAgent';
import { useActiveLink } from '@/hooks/useActiveLink/useActiveLink';

import { ItemLabel, ToolItem } from '../MenuItems.styles';

const MyPerformancesItem = () => {
  const { t } = useTranslation();

  const [isOpen, updateMenu] = useRecoilState(menuSelector);
  const currentAgent = useCurrentAgent();
  const isActive = useActiveLink('/agent/dashboard');

  if (!currentAgent?.id) {
    return <Fragment />;
  }

  return (
    <Link
      href="/agent/dashboard"
      id="sidebar-menu_dashboard"
      onMouseEnter={() => {
        if (!isOpen) {
          updateMenu(true);
        }
      }}
    >
      <ToolItem isActive={isActive} isOpen={isOpen}>
        <PerformancesIcon />
        <ItemLabel>{t('myPerformances')}</ItemLabel>
      </ToolItem>
    </Link>
  );
};

export default MyPerformancesItem;
